export class Warehouse{
  constructor(
    public ID:number,
    private name:string,
    private location:string
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/warehouse.model.ts